(() => {
  const doc = document;
  if (doc.__vacationScheduleInitialized) return;
  doc.__vacationScheduleInitialized = true;

  const MAX_DELAY = 2147483647;
  let timer = null;

  const deadline = (node, attribute) => {
    const raw = node.getAttribute(attribute);
    if (raw == null || raw.trim() === '') return null;
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : null;
  };

  function refresh() {
    if (timer !== null) clearTimeout(timer);
    timer = null;
    const now = Date.now() / 1000;
    let next = Infinity;

    doc.querySelectorAll('[data-vacation-end-at]').forEach((header) => {
      const end = deadline(header, 'data-vacation-end-at');
      if (end === null) return;
      if (now >= end) {
        const marquee = header.querySelector('[data-vacation-marquee]');
        if (marquee) marquee.remove();
        const dialog = header.querySelector('[data-vacation-dialog]');
        if (dialog) {
          if (dialog.open && typeof dialog.close === 'function') dialog.close();
          dialog.remove();
        }
        if (header.style && typeof header.style.setProperty === 'function') {
          header.style.setProperty('--q-header-vacation-height', '0px');
        }
        header.removeAttribute('data-vacation-end-at');
      } else next = Math.min(next, end);
    });

    doc.querySelectorAll('[data-expiring-text-at]').forEach((node) => {
      const end = deadline(node, 'data-expiring-text-at');
      if (end === null) return;
      if (now >= end) {
        const fallback = node.getAttribute('data-expired-text');
        if (fallback !== null) node.textContent = fallback;
        node.removeAttribute('data-expiring-text-at');
        node.removeAttribute('data-expired-text');
      } else next = Math.min(next, end);
    });

    if (next !== Infinity) {
      timer = setTimeout(refresh, Math.min(MAX_DELAY, Math.max(0, (next - now) * 1000)));
    }
  }

  refresh();
  window.addEventListener('pageshow', refresh);
  doc.addEventListener('visibilitychange', () => {
    if (doc.visibilityState === 'visible') refresh();
  });
  doc.addEventListener('shopify:section:load', refresh);
})();
